<template>
  <div class="pf1-main">

    <div class="c1-sticky-top">
    <!-- TOP BAR -->
    <div class="c1-tib" @click="pf1SlideOpen = null">
      <div class="c1-tib-side c1-tib-left" style="padding-left:0;gap:8px;">
        <div class="c1-viki-topface">
          <viki-face :mood="'neutral'" :speaking="false" :size="44" style="width:72px;height:44px;display:block;overflow:hidden;border-radius:0;"/>
        </div>
        <div class="c1-shift-wrap" @click.stop="c1ShiftMenuOpen = !c1ShiftMenuOpen; c1HamMenuOpen = false">
          <div class="c1-tib-shift-pill" :class="{ open: c1ShiftMenuOpen }">
            ⏱ {{ c1ShiftElapsed }}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:10px;height:10px;margin-left:3px;transition:transform .2s" :style="{ transform: c1ShiftMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)' }"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
        </div>
      </div>
      <div class="c1-tib-center">
        <div class="c1-tib-mod-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
          My Profile
        </div>
      </div>
      <div class="c1-tib-side c1-tib-right">
        <div class="c1-psel-wrap">
          <div class="c1-psel-btn" :class="{ active: pf1PanelIsOpen }" @click.stop="pf1PanelBtnClick()">
            <span class="c1-psel-btn-ico">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
            </span>
            <span class="c1-psel-btn-lbl">Menu</span>
            <svg class="c1-psel-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
          </div>
        </div>
        <div class="c1-ham-wrap" @click.stop>
          <button class="c1-ham-btn" :class="{ open: c1HamMenuOpen }" @click="c1HamMenuOpen = !c1HamMenuOpen; c1ShiftMenuOpen = false">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:18px;height:18px"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>
        </div>
      </div>
    </div>
    <!-- SHIFT DRAWER -->
    <div class="c1-top-drawer c1-shift-drawer" :class="{ open: c1ShiftMenuOpen }" @click.stop>
      <div class="c1-td-inner">
        <div class="c1-td-section-lbl">My Shift</div>
        <div class="c1-td-status-row">
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono">{{ c1ShiftStartTime ? new Date(c1ShiftStartTime).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : '—' }}</div>
            <div class="c1-td-stat-lbl">Started</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono" style="color:var(--c1-dp)">{{ c1ShiftElapsed }}</div>
            <div class="c1-td-stat-lbl">Elapsed</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1BathroomCount }}×</div>
            <div class="c1-td-stat-lbl">🚽 Bathroom</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1CoffeeCount }}×</div>
            <div class="c1-td-stat-lbl">☕ Coffee</div>
          </div>
        </div>
        <div class="c1-td-btn-row">
          <button class="c1-td-btn c1-td-btn-shift"   :class="{ active: c1Status === 'shift' }"   @click.stop="c1SetStatus('shift')">▶ On Shift</button>
          <button class="c1-td-btn c1-td-btn-bathroom" :class="{ active: c1Status === 'bathroom' }" @click.stop="c1SetStatus('bathroom')">🚽 Bathroom</button>
          <button class="c1-td-btn c1-td-btn-coffee"  :class="{ active: c1Status === 'coffee' }"  @click.stop="c1SetStatus('coffee')">☕ Coffee</button>
          <button class="c1-td-btn c1-td-btn-break"   :class="{ active: c1Status === 'break' }"   @click.stop="c1SetStatus('break')">⏸ Break</button>
          <button class="c1-td-btn c1-td-btn-lunch"   :class="{ active: c1Status === 'lunch' }"   @click.stop="c1SetStatus('lunch')">🍽 Lunch</button>
          <button class="c1-td-btn c1-td-btn-end"     @click.stop="c1SetStatus('end')">⏹ End Shift</button>
        </div>
      </div>
    </div>
    <!-- HAM NAV DRAWER -->
    <div class="c1-top-drawer c1-ham-drawer" :class="{ open: c1HamMenuOpen }" @click.stop>
      <div class="c1-td-inner c1-td-nav-grid">
        <router-link to="/clients1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-dp)"></span>Clients</router-link>
        <router-link to="/tasks1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-sc)"></span>Tasks</router-link>
        <router-link to="/stats1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-ld)"></span>Statistics</router-link>
        <router-link to="/chat1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-rf)"></span>Chat</router-link>
        <router-link to="/communications1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#3b82f6"></span>Communications</router-link>
        <router-link to="/affiliation1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#8b5cf6"></span>Affiliation</router-link>
        <router-link to="/finance1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#10b981"></span>Finance</router-link>
        <router-link to="/shifts1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#f59e0b"></span>Shifts</router-link>
        <router-link to="/users1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#06b6d4"></span>Users</router-link>
        <router-link to="/brokers1" class="c1-td-nav-item" :class="{ on: $route.path === '/brokers1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ec4899"></span>Brokers</router-link>
        <router-link to="/security1" class="c1-td-nav-item" :class="{ on: $route.path === '/security1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ef4444"></span>Security</router-link>
        <router-link to="/quiz1" class="c1-td-nav-item" :class="{ on: $route.path === '/quiz1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#a78bfa"></span>Quiz</router-link>
        <router-link to="/instruction1" class="c1-td-nav-item" :class="{ on: $route.path === '/instruction1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#64748b"></span>Instructions</router-link>
        <router-link to="/settings1" class="c1-td-nav-item" :class="{ on: $route.path === '/settings1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#94a3b8"></span>Settings</router-link>
        <router-link to="/profile1" class="c1-td-nav-item" :class="{ on: $route.path === '/profile1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#22d3ee"></span>My Profile</router-link>
      </div>
    </div>
    </div><!-- /c1-sticky-top -->

    <!-- Panel backdrop -->
    <transition name="c1-bd-fade">
      <div v-if="pf1SlideOpen" class="c1-panel-backdrop" @click.stop="pf1SlideOpen = null"></div>
    </transition>

    <!-- UNIFIED RIGHT PANEL -->
    <div class="c1-panel" :class="{ 'c1-panel--open': pf1PanelIsOpen }" @click.capture="pf1FilterPanelClick">
      <div class="c1-panel-track">
        <div class="c1-panel-screen">
          <!-- USER STRIP -->
          <div class="c1-nav-user-strip">
            <div class="c1-nav-av">
              {{ pf1Initials }}
              <span class="c1-nav-av-dot" :class="'c1-dst-' + c1Status"></span>
            </div>
            <div class="c1-nav-uinfo">
              <div class="c1-nav-uname">{{ pf1FullName }}</div>
              <div class="c1-nav-urole">{{ pf1RoleLabel }}</div>
            </div>
            <div class="c1-nav-status-wrap" @click.stop="c1StatusMenuOpen = !c1StatusMenuOpen">
              <div class="c1-nav-status-btn" :class="'c1-st-' + c1Status">
                <span class="c1-nav-status-sdot"></span>
                <span class="c1-nav-status-elapsed">{{ c1StatusElapsed }}</span>
              </div>
              <transition name="c1-sfade">
                <div v-if="c1StatusMenuOpen" class="c1-nav-status-menu">
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('available')"><span class="c1-nav-status-opt-dot c1-st-dot-available"></span>Available</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('bathroom')"><span class="c1-nav-status-opt-dot c1-st-dot-bathroom"></span>Bathroom</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('coffee')"><span class="c1-nav-status-opt-dot c1-st-dot-coffee"></span>Coffee break</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('shift')"><span class="c1-nav-status-opt-dot c1-st-dot-shift"></span>Start shift</div>
                  <div class="c1-nav-status-opt c1-sto-end" @click.stop="c1SetStatus('end')"><span class="c1-nav-status-opt-dot c1-st-dot-end"></span>End shift</div>
                </div>
              </transition>
            </div>
          </div>

          <!-- TIMEZONE BAR -->
          <div class="c1-nav-tz-bar">
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇬🇧</span><span class="c1-nav-tz-time">{{ pf1TzUK }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇮🇱</span><span class="c1-nav-tz-time">{{ pf1TzIL }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🏝</span><span class="c1-nav-tz-time">{{ pf1TzCB }}</span></div>
          </div>

          <!-- NAVIGATE MODE -->
          <div v-if="pf1NavMode === 'navigate'" class="c1-sl-body" style="padding:6px 0 12px">
            <div class="c1-psel-sub c1-psel-sub-back" @click.stop="pf1NavMode = 'panels'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><polyline points="15 18 9 12 15 6"/></svg>
              <span class="c1-psel-sub-lbl">My Profile</span>
            <span class="c1-nav-x-btn" @click.stop="pf1SlideOpen = null"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:15px;height:15px;display:block"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></span></div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">CRM</div>
            <router-link class="c1-psel-sub" to="/clients1" @click.native="pf1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Clients</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/tasks1" @click.native="pf1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Tasks</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/stats1" @click.native="pf1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Statistics</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/chat1" @click.native="pf1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Chat</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/communications1" @click.native="pf1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Communications</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/affiliation1" @click.native="pf1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Affiliation</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Sales</div>
            <router-link class="c1-psel-sub" to="/finance1" @click.native="pf1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Finance</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/shifts1" @click.native="pf1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Shifts</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/games1" @click.native="pf1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Games</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Team</div>
            <router-link class="c1-psel-sub" to="/users1" @click.native="pf1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Users</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/brokers1" @click.native="pf1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Brokers</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/security1" @click.native="pf1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Security</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Admin</div>
            <router-link class="c1-psel-sub" to="/quiz1" @click.native="pf1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Quiz</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/instruction1" @click.native="pf1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Instructions</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/settings1" @click.native="pf1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Settings</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/profile1" @click.native="pf1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">My Profile</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
          </div>

          <!-- PANELS MODE -->
          <div v-else class="c1-sl-body" style="padding:6px 0 12px">
            <div class="c1-psel-sub c1-psel-sub-navigate" @click.stop="pf1NavMode = 'navigate'">
              <span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span>
              <span class="c1-psel-sub-lbl" style="font-weight:600;color:var(--c1-dp)">My Profile</span>
              <span class="c1-psel-sub-hint">Go to another page</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- BODY -->
    <div class="pf1-body">

      <!-- LEFT: identity card -->
      <div class="pf1-card pf1-identity">

        <!-- Avatar -->
        <div class="pf1-av-wrap">
          <div class="pf1-av">{{ pf1Initials }}</div>
          <div class="pf1-av-dot" :class="{ on: pf1Online }"></div>
        </div>

        <div class="pf1-id-name">{{ pf1FullName }}</div>
        <div class="pf1-id-role">{{ pf1RoleLabel }}</div>
        <div class="pf1-id-email">{{ pf1User.email || '—' }}</div>

        <!-- Online toggle -->
        <div class="pf1-online-row">
          <span class="pf1-online-lbl">{{ pf1Online ? 'Online' : 'Offline' }}</span>
          <button class="pf1-toggle" :class="{ on: pf1Online }" @click="pf1Online = !pf1Online">
            <span class="pf1-toggle-knob"></span>
          </button>
        </div>

        <!-- Stats row -->
        <div class="pf1-stat-row">
          <div class="pf1-stat">
            <div class="pf1-stat-val">{{ pf1User.role || '—' }}</div>
            <div class="pf1-stat-lbl">Role ID</div>
          </div>
          <div class="pf1-stat">
            <div class="pf1-stat-val">{{ pf1User.team_id || '—' }}</div>
            <div class="pf1-stat-lbl">Team</div>
          </div>
          <div class="pf1-stat">
            <div class="pf1-stat-val">{{ pf1User.id || '—' }}</div>
            <div class="pf1-stat-lbl">User ID</div>
          </div>
        </div>

        <!-- MY TEAM CARD -->
        <div v-if="p1TeamData" class="p1-team-card">
          <div class="p1-tc-header" :style="{ background: p1TeamData.color || '#7c5cfc' }">
            <span class="p1-tc-emoji">{{ p1TeamData.emoji || '👥' }}</span>
            <span class="p1-tc-name">{{ p1TeamData.name }}</span>
          </div>
          <div class="p1-tc-body">
            <div style="font-size:11px;color:rgba(0,0,0,.5);margin-bottom:8px;">Manager: <strong style="color:#1a1a1a">{{ p1TeamData.manager || '—' }}</strong> &nbsp;·&nbsp; {{ (p1TeamData.members || []).length }} members</div>

            <div class="p1-tc-kpi-row">
              <div class="p1-tc-kpi">
                <div class="p1-tc-kpi-val" :style="{ color: p1TeamData.color || '#7c5cfc' }">${{ p1TeamDeposits }}</div>
                <div class="p1-tc-kpi-lbl">Team Deposits</div>
              </div>
              <div class="p1-tc-kpi">
                <div class="p1-tc-kpi-val" :style="{ color: p1TeamData.color || '#7c5cfc' }">#{{ p1MyRank }}</div>
                <div class="p1-tc-kpi-lbl">My Rank</div>
              </div>
              <div class="p1-tc-kpi">
                <div class="p1-tc-kpi-val" :style="{ color: p1TeamData.color || '#7c5cfc' }">{{ (p1TeamData.members || []).length }}</div>
                <div class="p1-tc-kpi-lbl">Members</div>
              </div>
            </div>

            <div class="p1-tc-members">
              <div
                v-for="(m, mi) in p1TeamMembersPreview"
                :key="mi"
                class="p1-tc-av"
                :style="{ background: p1TeamData.color || '#7c5cfc' }"
                :title="m.name"
              >{{ m.initials }}</div>
              <div v-if="p1TeamMembersOverflow > 0" class="p1-tc-av" style="background:#a09e98">+{{ p1TeamMembersOverflow }}</div>
            </div>

            <div class="p1-tc-vs">{{ p1TeamVsLine }}</div>
          </div>
        </div>
        <div v-else-if="p1TeamLoading" style="margin-top:16px;text-align:center;font-size:11px;color:#a09e98;">Loading team…</div>

        <!-- LOGOUT BUTTON -->
        <button class="pf1-logout-btn" @click="pf1Logout">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
          Sign Out
        </button>
      </div>

      <!-- RIGHT: tabs -->
      <div class="pf1-right">

        <!-- Tab bar -->
        <div class="pf1-tab-bar">
          <div class="pf1-tab" :class="{ on: pf1Tab === 'account' }" @click="pf1Tab = 'account'">
            <svg viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            Account
          </div>
          <div class="pf1-tab" :class="{ on: pf1Tab === 'password' }" @click="pf1Tab = 'password'">
            <svg viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            Password
          </div>
          <div class="pf1-tab" :class="{ on: pf1Tab === 'activity' }" @click="pf1Tab = 'activity'">
            <svg viewBox="0 0 24 24"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
            Activity
          </div>
        </div>

        <!-- ACCOUNT TAB -->
        <div v-if="pf1Tab === 'account'" class="pf1-tab-body">
          <div class="pf1-section-title">Personal Information</div>

          <div class="pf1-field-row">
            <div class="pf1-field">
              <label class="pf1-lbl">First Name</label>
              <input class="pf1-input" v-model="pf1Form.first_name" placeholder="First name" :disabled="!pf1EditMode" />
            </div>
            <div class="pf1-field">
              <label class="pf1-lbl">Last Name</label>
              <input class="pf1-input" v-model="pf1Form.last_name" placeholder="Last name" :disabled="!pf1EditMode" />
            </div>
          </div>

          <div class="pf1-field">
            <label class="pf1-lbl">Email</label>
            <input class="pf1-input" v-model="pf1Form.email" placeholder="Email address" :disabled="!pf1EditMode" />
          </div>

          <div class="pf1-field-row">
            <div class="pf1-field">
              <label class="pf1-lbl">VoIP User</label>
              <input class="pf1-input" :value="pf1User.voip_user || '—'" disabled />
            </div>
            <div class="pf1-field">
              <label class="pf1-lbl">Seniority</label>
              <input class="pf1-input" :value="pf1User.seniority || '—'" disabled />
            </div>
          </div>

          <div class="pf1-field">
            <label class="pf1-lbl">Role</label>
            <input class="pf1-input" :value="pf1RoleLabel" disabled />
          </div>

          <div class="pf1-actions">
            <button v-if="!pf1EditMode" class="pf1-btn pf1-btn-edit" @click="pf1StartEdit">
              <svg viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
              Edit Profile
            </button>
            <template v-else>
              <button class="pf1-btn pf1-btn-cancel" @click="pf1CancelEdit">Cancel</button>
              <button class="pf1-btn pf1-btn-save" :disabled="pf1Saving" @click="pf1SaveAccount">
                <span v-if="pf1Saving">Saving…</span>
                <span v-else>
                  <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                  Save Changes
                </span>
              </button>
            </template>
          </div>
        </div>

        <!-- PASSWORD TAB -->
        <div v-if="pf1Tab === 'password'" class="pf1-tab-body">
          <div class="pf1-section-title">Change Password</div>
          <div class="pf1-pw-notice">
            <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            Your new password must be at least 8 characters long.
          </div>

          <div class="pf1-field">
            <label class="pf1-lbl">Current Password</label>
            <div class="pf1-pw-wrap">
              <input class="pf1-input" :type="pf1ShowCurr ? 'text' : 'password'" v-model="pf1PwForm.current" placeholder="••••••••" />
              <button class="pf1-pw-eye" @click="pf1ShowCurr = !pf1ShowCurr">
                <svg v-if="!pf1ShowCurr" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                <svg v-else viewBox="0 0 24 24"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
              </button>
            </div>
          </div>

          <div class="pf1-field">
            <label class="pf1-lbl">New Password</label>
            <div class="pf1-pw-wrap">
              <input class="pf1-input" :type="pf1ShowNew ? 'text' : 'password'" v-model="pf1PwForm.newPw" placeholder="••••••••" />
              <button class="pf1-pw-eye" @click="pf1ShowNew = !pf1ShowNew">
                <svg v-if="!pf1ShowNew" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                <svg v-else viewBox="0 0 24 24"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
              </button>
            </div>
            <!-- strength bar -->
            <div v-if="pf1PwForm.newPw" class="pf1-pw-strength">
              <div class="pf1-pw-bar">
                <div class="pf1-pw-fill" :style="{ width: pf1PwStrength.pct + '%', background: pf1PwStrength.color }"></div>
              </div>
              <span class="pf1-pw-strength-lbl" :style="{ color: pf1PwStrength.color }">{{ pf1PwStrength.label }}</span>
            </div>
          </div>

          <div class="pf1-field">
            <label class="pf1-lbl">Confirm New Password</label>
            <input class="pf1-input" :type="pf1ShowNew ? 'text' : 'password'" v-model="pf1PwForm.confirm" placeholder="••••••••"
              :class="{ 'pf1-input--err': pf1PwForm.confirm && pf1PwForm.confirm !== pf1PwForm.newPw }" />
            <div v-if="pf1PwForm.confirm && pf1PwForm.confirm !== pf1PwForm.newPw" class="pf1-field-err">Passwords do not match</div>
          </div>

          <div class="pf1-actions">
            <button class="pf1-btn pf1-btn-save" :disabled="!pf1PwCanSubmit || pf1PwSaving" @click="pf1SavePassword">
              <span v-if="pf1PwSaving">Updating…</span>
              <span v-else>Update Password</span>
            </button>
          </div>
        </div>

        <!-- ACTIVITY TAB -->
        <div v-if="pf1Tab === 'activity'" class="pf1-tab-body">
          <div class="pf1-section-title">Recent Activity</div>
          <div v-if="pf1LoadingActivity" class="pf1-loading">
            <div class="c1-spinner"></div>
          </div>
          <div v-else-if="!pf1Activity.length" class="pf1-empty">
            <svg viewBox="0 0 24 24"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
            No recent activity found
          </div>
          <div v-else class="pf1-activity-list">
            <div v-for="(act, ai) in pf1Activity" :key="ai" class="pf1-act-row">
              <div class="pf1-act-dot" :style="{ background: act.color }"></div>
              <div class="pf1-act-body">
                <div class="pf1-act-msg">{{ act.message }}</div>
                <div class="pf1-act-time">{{ act.time }}</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- TOAST -->
    <transition name="pf1-toast-fade">
      <div v-if="pf1Toast" class="pf1-toast" :style="{ background: pf1Toast.color }">
        <svg v-if="pf1Toast.ok" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
        <svg v-else viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        {{ pf1Toast.msg }}
      </div>
    </transition>

  </div>
</template>

<script>
import VikiFace from "../../clients1.feature/VikiFace.vue";
import axios from 'axios';

const ROLE_MAP = {
  1: 'Admin', 2: 'Team Leader', 3: 'Manager', 4: 'Senior Agent',
  5: 'Agent', 6: 'Junior Agent', 7: 'New Agent', 8: 'Support',
  9: 'Retention', 10: 'Finance', 12: 'Super Admin',
};

export default {
  name: 'Profile1',

  components: { VikiFace },

  data() {
    return {
      c1Status: 'shift',
      c1StatusSince: 0,
      c1StatusElapsed: '00:00',
      c1StatusMenuOpen: false,
      _c1StatusInterval: null,
      c1HamMenuOpen: false,
      c1ShiftMenuOpen: false,
      c1ShiftElapsed: '00:00',
      c1ShiftStartTime: 0,
      c1BathroomCount: 0,
      c1CoffeeCount: 0,
      c1WeekLog: [],
      pf1Tab: 'account',
      pf1EditMode: false,
      pf1Saving: false,
      pf1PwSaving: false,
      pf1LoadingActivity: false,
      pf1Toast: null,
      pf1Form: { first_name: '', last_name: '', email: '' },
      pf1PwForm: { current: '', newPw: '', confirm: '' },
      pf1ShowCurr: false,
      pf1ShowNew: false,
      pf1Activity: [],
      pf1SlideOpen: 'nav',
      pf1NavMode: 'navigate',
      c1VikiMood: 'neutral',
      c1VikiSpeaking: false,
      p1TeamData: null,
      p1TeamLoading: false,
      p1TeamLeaderboard: [],
    };
  },
  computed: {
    pf1User() {
      return (this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user)
          || (this.$store.state.auth && this.$store.state.auth.user) || {};
    },
    pf1Initials() {
      const u = this.pf1User;
      return (((u.first_name || '')[0] || '') + ((u.last_name || '')[0] || '')).toUpperCase() || 'GN';
    },
    pf1FullName() {
      const u = this.pf1User;
      return ((u.first_name || '') + ' ' + (u.last_name || '')).trim() || 'User';
    },
    pf1RoleLabel() {
      return ROLE_MAP[this.pf1User.role] || 'Agent';
    },
    pf1Token() {
      return this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.token
          || localStorage.getItem('user-token') || '';
    },
    pf1Headers() {
      return { Authorization: 'Bearer ' + this.pf1Token };
    },
    pf1PwStrength() {
      const pw = this.pf1PwForm.newPw;
      if (!pw) return { pct: 0, color: '#e5e7eb', label: '' };
      let score = 0;
      if (pw.length >= 8) score++;
      if (/[A-Z]/.test(pw)) score++;
      if (/[0-9]/.test(pw)) score++;
      if (/[^A-Za-z0-9]/.test(pw)) score++;
      const map = [
        { pct: 20, color: '#ef4444', label: 'Weak' },
        { pct: 45, color: '#f59e0b', label: 'Fair' },
        { pct: 70, color: '#0ea5e9', label: 'Good' },
        { pct: 100, color: '#22c55e', label: 'Strong' },
      ];
      return map[score - 1] || map[0];
    },
    pf1PwCanSubmit() {
      const f = this.pf1PwForm;
      return f.current && f.newPw && f.newPw.length >= 8 && f.newPw === f.confirm;
    },
    pf1PanelIsOpen() {
      return this.pf1SlideOpen === 'panel';
    },
    c1CurrentPageLabel() {
      const map = {
        '/clients1': 'Clients', '/tasks1': 'Tasks', '/stats1': 'Statistics',
        '/chat1': 'Chat', '/communications1': 'Communications', '/affiliation1': 'Affiliation',
        '/finance1': 'Finance', '/shifts1': 'Shifts', '/games1': 'Games',
        '/users1': 'Users', '/brokers1': 'Brokers', '/security1': 'Security',
        '/quiz1': 'Quiz', '/instruction1': 'Instructions', '/settings1': 'Settings',
        '/profile1': 'My Profile',
      };
      return map[this.$route.path] || 'CRM';
    },
    pf1TzUK() { return this.pf1TzTime('Europe/London'); },
    pf1TzIL() { return this.pf1TzTime('Asia/Jerusalem'); },
    pf1TzCB() { return this.pf1TzTime('America/Cayman'); },

    p1TeamDeposits() {
      if (!this.p1TeamData) return '0';
      const deposits = this.p1TeamData.total_deposits || this.p1TeamData.deposits || 0;
      return Number(deposits).toLocaleString();
    },
    p1MyRank() {
      if (!this.p1TeamLeaderboard.length) return '—';
      const userId = this.pf1User.id;
      const idx = this.p1TeamLeaderboard.findIndex(r => String(r.user_id) === String(userId) || String(r.id) === String(userId));
      return idx >= 0 ? idx + 1 : '—';
    },
    p1TeamMembersPreview() {
      if (!this.p1TeamData || !this.p1TeamData.members) return [];
      return this.p1TeamData.members.slice(0, 8).map(m => {
        const name = [m.first_name, m.last_name].filter(Boolean).join(' ') || m.name || m.username || 'U';
        const parts = name.trim().split(' ');
        const initials = parts.length >= 2
          ? (parts[0][0] + parts[1][0]).toUpperCase()
          : name.substring(0, 2).toUpperCase();
        return { name, initials };
      });
    },
    p1TeamMembersOverflow() {
      if (!this.p1TeamData || !this.p1TeamData.members) return 0;
      return Math.max(0, this.p1TeamData.members.length - 8);
    },
    p1TeamVsLine() {
      if (!this.p1TeamData) return '';
      const myDeposits = Number(this.p1TeamData.total_deposits || this.p1TeamData.deposits || 0);
      const rivals = this.p1TeamData.rivals;
      if (!rivals || !rivals.length) return 'No rival team data yet.';
      const rival = rivals[0];
      const rivalDeposits = Number(rival.total_deposits || rival.deposits || 0);
      const diff = Math.abs(myDeposits - rivalDeposits);
      const diffStr = '$' + diff.toLocaleString();
      if (myDeposits > rivalDeposits) return `Your team is leading vs ${rival.name}! Leading by ${diffStr} ⚡`;
      if (myDeposits < rivalDeposits) return `Trailing ${rival.name} by ${diffStr} in deposits`;
      return `Tied with ${rival.name} this month`;
    },
  },
  beforeDestroy() {
    if (this._c1StatusInterval) clearInterval(this._c1StatusInterval);
  },

  created() {
    if (sessionStorage.getItem('c1keepNav')) {
      sessionStorage.removeItem('c1keepNav');
      this.pf1SlideOpen = 'nav';
      this.pf1NavMode = 'panels';
    }
    sessionStorage.removeItem('c1openPanel');
  },

  mounted() {
    document.documentElement.style.setProperty('--gnm-sw', '0px');
    this.pf1InitForm();
    this.pf1LoadActivity();
    this.p1FetchTeam();
    const savedStatus = localStorage.getItem('c1_status');
    const savedSince  = localStorage.getItem('c1_status_since');
    const today = new Date().toISOString().slice(0, 10);
    const savedShiftDay = localStorage.getItem('c1_shift_day');
    if (savedShiftDay !== today) {
      this.c1ShiftStartTime = Date.now();
      this.c1BathroomCount = 0;
      this.c1CoffeeCount = 0;
      localStorage.setItem('c1_status', 'shift');
      localStorage.setItem('c1_status_since', String(Date.now()));
      localStorage.setItem('c1_shift_start', String(Date.now()));
      localStorage.setItem('c1_shift_day', today);
      localStorage.setItem('c1_bathroom_count', '0');
      localStorage.setItem('c1_coffee_count', '0');
    } else {
      if (savedStatus) this.c1Status = savedStatus;
      this.c1ShiftStartTime = parseInt(localStorage.getItem('c1_shift_start') || String(Date.now()), 10);
      this.c1BathroomCount = parseInt(localStorage.getItem('c1_bathroom_count') || '0', 10);
      this.c1CoffeeCount   = parseInt(localStorage.getItem('c1_coffee_count') || '0', 10);
    }
    this.c1StatusSince = savedSince ? parseInt(savedSince, 10) : Date.now();
    this._c1StatusInterval = setInterval(this.c1TickStatus, 1000);
  },
  watch: {
    pf1User() { this.pf1InitForm(); },
  },
  methods: {
    c1SetStatus(s) {
      if (s === 'bathroom') this.c1BathroomCount++;
      if (s === 'coffee')   this.c1CoffeeCount++;
      this.c1Status = s;
      this.c1StatusSince = Date.now();
      this.c1StatusElapsed = '00:00';
      this.c1ShiftMenuOpen = false;
      localStorage.setItem('c1_status', s);
      localStorage.setItem('c1_status_since', String(this.c1StatusSince));
      if (s === 'bathroom') localStorage.setItem('c1_bathroom_count', String(this.c1BathroomCount));
      if (s === 'coffee')   localStorage.setItem('c1_coffee_count',   String(this.c1CoffeeCount));
      if (s === 'end') this.c1SaveTodayToLog();
    },
    c1TickStatus() {
      const fmtSec = (sec) => {
        const h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s2 = sec % 60;
        return h > 0
          ? String(h).padStart(2,'0') + ':' + String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0')
          : String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0');
      };
      this.c1StatusElapsed = fmtSec(Math.floor((Date.now() - this.c1StatusSince) / 1000));
      this.c1ShiftElapsed  = fmtSec(Math.floor((Date.now() - this.c1ShiftStartTime) / 1000));
    },
    c1SaveTodayToLog() {
      try {
        const today = new Date().toISOString().slice(0, 10);
        const workedMin = Math.floor((Date.now() - this.c1ShiftStartTime) / 60000);
        const log = JSON.parse(localStorage.getItem('c1_week_log') || '[]').filter(r => r.date !== today);
        log.unshift({ date: today, workedMin: Math.max(0, workedMin), bathroom: this.c1BathroomCount, coffee: this.c1CoffeeCount });
        localStorage.setItem('c1_week_log', JSON.stringify(log.slice(0, 14)));
        this.c1WeekLog = log.slice(0, 14);
      } catch(e) {}
    },
    pf1InitForm() {
      const u = this.pf1User;
      this.pf1Form = { first_name: u.first_name || '', last_name: u.last_name || '', email: u.email || '' };
    },
    pf1StartEdit() {
      this.pf1InitForm();
      this.pf1EditMode = true;
    },
    pf1CancelEdit() {
      this.pf1InitForm();
      this.pf1EditMode = false;
    },
    async pf1SaveAccount() {
      this.pf1Saving = true;
      try {
        await axios.put('/api/user/profile', this.pf1Form, { headers: this.pf1Headers });
        this.pf1EditMode = false;
        this.pf1ShowToast('Profile updated', true);
        this.$store.dispatch('user/getProfile').catch(() => {});
      } catch(e) {
        this.pf1ShowToast('Failed to save — try again', false);
      } finally { this.pf1Saving = false; }
    },
    async pf1SavePassword() {
      if (!this.pf1PwCanSubmit) return;
      this.pf1PwSaving = true;
      try {
        await axios.put('/api/user/password', {
          current_password: this.pf1PwForm.current,
          new_password: this.pf1PwForm.newPw,
        }, { headers: this.pf1Headers });
        this.pf1PwForm = { current: '', newPw: '', confirm: '' };
        this.pf1ShowToast('Password updated successfully', true);
      } catch(e) {
        const msg = (e.response && e.response.data && e.response.data.message) || 'Incorrect current password';
        this.pf1ShowToast(msg, false);
      } finally { this.pf1PwSaving = false; }
    },
    async pf1LoadActivity() {
      this.pf1LoadingActivity = true;
      try {
        const res = await axios.get('/api/user/activity', { headers: this.pf1Headers });
        const raw = Array.isArray(res.data) ? res.data : ((res.data && res.data.data) || []);
        this.pf1Activity = raw.slice(0, 20).map(a => ({
          message: a.message || a.action || a.description || 'Activity',
          time: a.created_at || a.time || '',
          color: a.color || '#7c5cfc',
        }));
      } catch(e) {
        // Fallback: show login session info
        this.pf1Activity = [
          { message: 'Logged in', time: new Date().toLocaleString(), color: '#22c55e' },
        ];
      } finally { this.pf1LoadingActivity = false; }
    },
    pf1FilterPanelClick(e) {
      // Panel stays open after selecting — user uses back (←) or X to close
    },
    pf1PanelBtnClick() {
      this.pf1SlideOpen = this.pf1PanelIsOpen ? null : 'nav';
    },
    pf1TzTime(tz) {
      return new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', timeZone: tz });
    },
    pf1Logout() {
      this.$store.dispatch('user/logOut');
    },
    pf1ShowToast(msg, ok) {
      this.pf1Toast = { msg, ok, color: ok ? '#16a34a' : '#dc2626' };
      setTimeout(() => { this.pf1Toast = null; }, 3200);
    },
    async p1FetchTeam() {
      this.p1TeamLoading = true;
      try {
        const teamId = this.pf1User.team_id;
        const [teamsRes, lbRes] = await Promise.allSettled([
          axios.get('/api/admin/teams', { headers: this.pf1Headers }),
          axios.get('/api/admin/teams/leaderboard?metric=deposits&period=month', { headers: this.pf1Headers }),
        ]);

        if (teamsRes.status === 'fulfilled') {
          const raw = Array.isArray(teamsRes.value.data)
            ? teamsRes.value.data
            : (teamsRes.value.data && teamsRes.value.data.data) || [];
          const myTeam = raw.find(t => String(t.id) === String(teamId));
          if (myTeam) {
            // attach rival info from other teams
            const others = raw.filter(t => String(t.id) !== String(teamId));
            myTeam.rivals = others.map(t => ({
              name: t.name,
              total_deposits: t.total_deposits || t.deposits || 0,
            }));
            this.p1TeamData = myTeam;
          }
        }

        if (lbRes.status === 'fulfilled') {
          const lb = Array.isArray(lbRes.value.data)
            ? lbRes.value.data
            : (lbRes.value.data && lbRes.value.data.data) || [];
          this.p1TeamLeaderboard = lb;
        }
      } catch (e) {
        // Silently fail — team card just won't show
      } finally {
        this.p1TeamLoading = false;
      }
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700;9..40,800&display=swap');

.pf1-main {
  /* Aliases so shared c1-design.css panel CSS resolves correctly */
  --c1-card:  #ffffff;
  --c1-bg:    #f9f9f8;
  --c1-brd:   #e4e3df;
  --c1-brd-l: #eeedea;
  --c1-t1:    #1a1a1a;
  --c1-t2:    #6b6963;
  --c1-t3:    #a09e98;
  padding-left: var(--gnm-sw, 220px);
  min-height: 100vh;
  background: #f9f9f8;
  font-family: 'DM Sans', system-ui, sans-serif;
  box-sizing: border-box;
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

/* BODY LAYOUT */
.pf1-body {
  display: flex;
  gap: 20px;
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto;
  align-items: flex-start;
}
@media (max-width: 767px) {
  .pf1-main { padding-left: 0; }
  .pf1-body { flex-direction: column; padding: 12px; }
}
@media (max-width: 480px) {
  .pf1-body { padding: 8px; }
}

/* CARD BASE */
.pf1-card {
  background: #fff;
  border: 1px solid #e4e3df;
  border-radius: 14px;
  overflow: hidden;
}

/* IDENTITY CARD */
.pf1-identity {
  width: 240px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 28px 20px 20px;
  gap: 6px;
}
@media (max-width: 767px) { .pf1-identity { width: 100%; } }

.pf1-av-wrap {
  position: relative;
  margin-bottom: 6px;
}
.pf1-av {
  width: 72px; height: 72px; border-radius: 50%;
  background: linear-gradient(135deg, #7c5cfc 0%, #9d7ff8 100%);
  color: #fff; font-size: 22px; font-weight: 800;
  display: flex; align-items: center; justify-content: center;
  letter-spacing: -.5px;
  box-shadow: 0 4px 16px rgba(124,92,252,.3);
}
.pf1-av-dot {
  position: absolute; bottom: 3px; right: 3px;
  width: 14px; height: 14px; border-radius: 50%;
  border: 2.5px solid #fff;
  background: #9ca3af;
  transition: background .2s;
}
.pf1-av-dot.on { background: #22c55e; }

.pf1-id-name {
  font-size: 15px; font-weight: 800; color: #1a1a1a;
  letter-spacing: -.4px; text-align: center; margin-top: 4px;
}
.pf1-id-role {
  font-size: 11px; font-weight: 600; color: #7c5cfc;
  background: rgba(124,92,252,.1); border-radius: 50px;
  padding: 2px 10px; margin: 2px 0;
}
.pf1-id-email {
  font-size: 11px; color: #a09e98; text-align: center;
  word-break: break-all;
}

/* ONLINE TOGGLE */
.pf1-online-row {
  display: flex; align-items: center; gap: 10px; margin-top: 10px;
}
.pf1-online-lbl { font-size: 11px; font-weight: 600; color: #6b6963; }
.pf1-toggle {
  width: 36px; height: 20px; border-radius: 10px;
  background: #e4e3df; border: none; cursor: pointer;
  position: relative; padding: 0;
  transition: background .2s;
}
.pf1-toggle.on { background: #22c55e; }
.pf1-toggle-knob {
  width: 14px; height: 14px; border-radius: 50%; background: #fff;
  position: absolute; top: 3px; left: 3px;
  transition: transform .2s;
  box-shadow: 0 1px 3px rgba(0,0,0,.2);
}
.pf1-toggle.on .pf1-toggle-knob { transform: translateX(16px); }

/* STAT ROW */
.pf1-stat-row {
  display: flex; gap: 0; margin-top: 14px; width: 100%;
  border: 1px solid #eeedea; border-radius: 10px; overflow: hidden;
}
.pf1-stat {
  flex: 1; text-align: center; padding: 10px 6px;
  border-right: 1px solid #eeedea;
}
.pf1-stat:last-child { border-right: none; }
.pf1-stat-val { font-size: 14px; font-weight: 800; color: #1a1a1a; }
.pf1-stat-lbl { font-size: 9px; font-weight: 600; text-transform: uppercase; letter-spacing: .6px; color: #a09e98; margin-top: 2px; }

/* LOGOUT BUTTON */
.pf1-logout-btn {
  display: flex; align-items: center; gap: 8px;
  width: 100%; margin-top: 18px;
  padding: 11px 16px;
  border: 1.5px solid #fee2e2; border-radius: 10px;
  background: rgba(239,68,68,.05); color: #dc2626;
  font-size: 13px; font-weight: 700; cursor: pointer;
  transition: background .15s, border-color .15s;
  justify-content: center;
  font-family: 'DM Sans', sans-serif;
}
.pf1-logout-btn:hover { background: rgba(239,68,68,.1); border-color: #fca5a5; }
.pf1-logout-btn svg { width: 15px; height: 15px; stroke: currentColor; flex-shrink: 0; }

/* RIGHT PANEL */
.pf1-right {
  flex: 1; min-width: 0;
}

/* TAB BAR */
.pf1-tab-bar {
  display: flex; gap: 4px; padding: 4px;
  background: #fff; border: 1px solid #e4e3df; border-radius: 12px;
  margin-bottom: 14px;
}
.pf1-tab {
  display: flex; align-items: center; gap: 7px;
  flex: 1; padding: 9px 14px;
  border-radius: 9px; cursor: pointer;
  font-size: 12px; font-weight: 600; color: #6b6963;
  transition: background .12s, color .12s;
  justify-content: center;
}
.pf1-tab svg { width: 14px; height: 14px; fill: none; stroke: currentColor; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; flex-shrink: 0; }
.pf1-tab:hover { background: rgba(0,0,0,.04); color: #1a1a1a; }
.pf1-tab.on { background: #7c5cfc; color: #fff; }
.pf1-tab.on svg { stroke: #fff; }

/* TAB BODY */
.pf1-tab-body {
  background: #fff; border: 1px solid #e4e3df; border-radius: 12px;
  padding: 20px 22px;
}

.pf1-section-title {
  font-size: 13px; font-weight: 800; color: #1a1a1a;
  letter-spacing: -.3px; margin-bottom: 18px;
  padding-bottom: 12px; border-bottom: 1px solid #eeedea;
}

/* FIELDS */
.pf1-field { margin-bottom: 14px; }
.pf1-field-row { display: flex; gap: 12px; }
.pf1-field-row .pf1-field { flex: 1; }
@media (max-width: 500px) { .pf1-field-row { flex-direction: column; } }

.pf1-lbl { font-size: 11px; font-weight: 700; color: #6b6963; display: block; margin-bottom: 5px; }
.pf1-input {
  width: 100%; padding: 9px 12px;
  border: 1.5px solid #e4e3df; border-radius: 8px;
  font-size: 12px; font-weight: 500; color: #1a1a1a;
  background: #fff; outline: none; box-sizing: border-box;
  font-family: 'DM Sans', sans-serif;
  transition: border-color .15s;
}
.pf1-input:focus { border-color: #7c5cfc; }
.pf1-input:disabled { background: #fafaf9; color: #6b6963; cursor: default; }
.pf1-input--err { border-color: #ef4444 !important; }
.pf1-field-err { font-size: 11px; color: #ef4444; margin-top: 4px; font-weight: 500; }

/* PASSWORD FIELD */
.pf1-pw-wrap { position: relative; }
.pf1-pw-wrap .pf1-input { padding-right: 38px; }
.pf1-pw-eye {
  position: absolute; right: 8px; top: 50%; transform: translateY(-50%);
  width: 26px; height: 26px; border: none; background: none; cursor: pointer;
  display: flex; align-items: center; justify-content: center; color: #a09e98;
}
.pf1-pw-eye svg { width: 14px; height: 14px; fill: none; stroke: currentColor; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.pf1-pw-strength { display: flex; align-items: center; gap: 8px; margin-top: 6px; }
.pf1-pw-bar { flex: 1; height: 4px; background: #e4e3df; border-radius: 2px; overflow: hidden; }
.pf1-pw-fill { height: 100%; border-radius: 2px; transition: width .3s, background .3s; }
.pf1-pw-strength-lbl { font-size: 10px; font-weight: 700; min-width: 40px; }

.pf1-pw-notice {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 12px; background: rgba(124,92,252,.07);
  border: 1px solid rgba(124,92,252,.18); border-radius: 8px;
  font-size: 11px; font-weight: 500; color: #5b21b6;
  margin-bottom: 16px;
}
.pf1-pw-notice svg { width: 14px; height: 14px; fill: none; stroke: currentColor; stroke-width: 2; flex-shrink: 0; }

/* ACTIONS */
.pf1-actions { display: flex; gap: 8px; margin-top: 18px; }
.pf1-btn {
  display: flex; align-items: center; gap: 6px;
  padding: 9px 18px; border-radius: 8px; cursor: pointer;
  font-size: 12px; font-weight: 700; border: none;
  font-family: 'DM Sans', sans-serif; transition: opacity .15s;
}
.pf1-btn:disabled { opacity: .4; cursor: default; }
.pf1-btn svg { width: 13px; height: 13px; fill: none; stroke: currentColor; stroke-width: 2.5; stroke-linecap: round; flex-shrink: 0; }
.pf1-btn-edit { background: rgba(124,92,252,.1); color: #7c5cfc; }
.pf1-btn-edit:hover { background: rgba(124,92,252,.16); }
.pf1-btn-save { background: #7c5cfc; color: #fff; }
.pf1-btn-save:hover:not(:disabled) { background: #6d4ef0; }
.pf1-btn-cancel { background: #f3f4f6; color: #6b7280; border: 1px solid #e5e7eb; }
.pf1-btn-cancel:hover { background: #e5e7eb; }

/* ACTIVITY */
.pf1-loading { display: flex; justify-content: center; padding: 30px 0; }
.pf1-empty {
  display: flex; flex-direction: column; align-items: center; gap: 10px;
  padding: 40px 0; color: #a09e98; font-size: 13px; font-weight: 500;
}
.pf1-empty svg { width: 32px; height: 32px; fill: none; stroke: currentColor; stroke-width: 1.5; opacity: .5; }

.pf1-activity-list { display: flex; flex-direction: column; gap: 12px; }
.pf1-act-row { display: flex; align-items: flex-start; gap: 12px; }
.pf1-act-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; margin-top: 5px; }
.pf1-act-body { flex: 1; min-width: 0; }
.pf1-act-msg { font-size: 12px; font-weight: 600; color: #1a1a1a; }
.pf1-act-time { font-size: 10px; color: #a09e98; margin-top: 2px; }

/* TOAST */
.pf1-toast {
  position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%);
  display: flex; align-items: center; gap: 8px;
  padding: 11px 20px; border-radius: 10px;
  color: #fff; font-size: 13px; font-weight: 600;
  box-shadow: 0 4px 20px rgba(0,0,0,.2); z-index: 9999; white-space: nowrap;
  font-family: 'DM Sans', sans-serif;
}
.pf1-toast svg { width: 16px; height: 16px; fill: none; stroke: #fff; stroke-width: 2.5; stroke-linecap: round; flex-shrink: 0; }
.pf1-toast-fade-enter-active, .pf1-toast-fade-leave-active { transition: opacity .25s, transform .25s; }
.pf1-toast-fade-enter, .pf1-toast-fade-leave-to { opacity: 0; transform: translateX(-50%) translateY(10px); }

/* ── MY TEAM CARD ── */
.p1-team-card { border-radius: 14px; overflow: hidden; border: 1px solid rgba(0,0,0,.08); margin-top: 20px; width: 100%; }
.p1-tc-header { padding: 14px 18px; display: flex; align-items: center; gap: 10px; }
.p1-tc-emoji { font-size: 24px; }
.p1-tc-name { font-size: 16px; font-weight: 700; color: #fff; }
.p1-tc-body { padding: 16px 18px; background: #fff; }
.p1-tc-kpi-row { display: flex; gap: 16px; margin-bottom: 14px; }
.p1-tc-kpi { flex: 1; }
.p1-tc-kpi-val { font-size: 18px; font-weight: 700; }
.p1-tc-kpi-lbl { font-size: 10px; color: #a09e98; text-transform: uppercase; letter-spacing: .5px; margin-top: 2px; }
.p1-tc-members { display: flex; margin-bottom: 12px; }
.p1-tc-av { width: 30px; height: 30px; border-radius: 50%; border: 2px solid #fff; display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 700; color: #fff; margin-left: -6px; box-shadow: 0 1px 4px rgba(0,0,0,.15); }
.p1-tc-av:first-child { margin-left: 0; }
.p1-tc-vs { font-size: 12px; color: #6b6963; padding: 8px 12px; background: #f9f9f8; border-radius: 8px; border: 1px solid #eeedea; }
</style>
